import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingFareOptimisationCardComponent } from "./booking-fare-optimisation-card.component";
import {
    FareOptimisationNavigationComponent
} from "./components/fare-optimisation-navigation/fare-optimisation-navigation.component";
import { BtnModule } from "libraries/ui_button/btn.module";
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import { CardModule } from "libraries/ui_card/card.module";
import { FareOptimisationListComponent } from "libraries/component/fare-optimisation-list/fare-optimisation-list.component";
import { BookingPriceCardModule } from "libraries/component/booking-information/components/booking-price-card/booking-price-card.module";
import {
    FareOptimisationDetailComponent
} from './components/fare-optimisation-detail/fare-optimisation-detail.component';
import { NotificationModule } from "libraries/component/notification/notification.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { FareOptimisationServiceModule } from "libraries/service/fare-optimisation/fare-optimisation-service.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MatDialogModule } from "@angular/material/dialog";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { TextFieldModule } from "libraries/module/formbuilder/fields/text-field/text-field.module";
import { TextModule } from "libraries/module/formbuilder/fields/text/text.module";
import { DateModule } from "libraries/module/formbuilder/fields/date/date.module";
import { NumberModule } from "libraries/module/formbuilder/fields/number/number.module";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatRadioModule } from "@angular/material/radio";
import { LocalizedModule } from "libraries/pipes/localized/localized.module";
import { PricePipeModule } from "libraries/pipes/price/price-pipe.module";
import { ComboboxFieldModule } from "libraries/module/formbuilder/fields/combobox-field/combobox-field.module";
import {
    FareOptimisationRejectFormModule
} from "libraries/component/booking-information/components/booking-fare-optimisation-card/components/fare-optimisation-reject-form/fare-optimisation-reject-form.module";
import { FareOptimisationResourceModule } from "libraries/service/resources/fare-optimisation/fare-optimisation-resource.module";

@NgModule({
    declarations: [
        BookingFareOptimisationCardComponent,
        FareOptimisationNavigationComponent,
        FareOptimisationListComponent,
        FareOptimisationDetailComponent,
    ],
    exports: [
        BookingFareOptimisationCardComponent,
        FareOptimisationListComponent,
    ],
    imports: [
        BookingPriceCardModule,
        BtnModule,
        CardModule,
        CommonModule,
        FareOptimisationServiceModule,
        LoaderModule,
        MultiselectModule,
        NotificationModule,
        FontAwesomeModule,
        MatDialogModule,
        FormsModule,
        MatButtonModule,
        TextFieldModule,
        TextModule,
        ReactiveFormsModule,
        DateModule,
        NumberModule,
        MatButtonToggleModule,
        MatRadioModule,
        LocalizedModule,
        PricePipeModule,
        ComboboxFieldModule,
        FareOptimisationRejectFormModule,
        FareOptimisationResourceModule
    ]
})
export class BookingFareOptimisationCardModule {
}
